module.exports = "./img/55f0eafe66b05cd5d24f8f3cf4b5ae8f.jpg";